import React from 'react'
import Table from '@common/Table'
import store from '../store'
import columns from './column'

export default () => (
  <Table style={{ marginTop: 20 }} store={store} columns={columns} />
)
